/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const breakpointsTokens = {
  GlobalMobile: 599,
  GlobalTabletPortrait: 899,
  GlobalTabletLandscape: 1199,
  GlobalDesktopNormal: 1535,
  GlobalDesktopLarge: 2000,
} as const;

export const colorTokens = {
  GlobalBackgroundInputBaseDefault: '#ffffff',
  GlobalBackgroundInputBaseDisabled: '#ebecec',
  GlobalBackgroundContainerBaseDefault: '#ffffff',
  GlobalBackgroundContainerBaseHover: '#ebecec',
  GlobalBackgroundContainerBrandDefault: '#1c2222',
  GlobalBackgroundContainerBrandDown: '#232b2b',
  GlobalBackgroundContainerTransparentDefault: 'rgba(0, 0, 0, 0)',
  GlobalBackgroundShinePrimaryDefault: '#dedfdf',
  GlobalBackgroundShineSecondaryDefault: '#ebecec',
  GlobalBackgroundFeedbackInformationalIntensity10Default: '#eaf0f8',
  GlobalBackgroundFeedbackInformationalIntensity20Default: '#dfe8f4',
  GlobalBackgroundFeedbackInformationalIntensity30Default: '#c0d1e9',
  GlobalBackgroundFeedbackInformationalIntensity40Default: '#8babd6',
  GlobalBackgroundFeedbackInformationalIntensity60Default: '#2c67b5',
  GlobalBackgroundFeedbackInformationalIntensity70Default: '#285da3',
  GlobalBackgroundFeedbackInformationalIntensity90Default: '#1a3e6d',
  GlobalBackgroundFeedbackPositiveIntensity20Default: '#d6efec',
  GlobalBackgroundFeedbackNegativeIntensity20Default: '#f8d2d8',
  GlobalBackgroundFeedbackNoticeIntensity10Default: '#fcf0ee',
  GlobalBackgroundFeedbackPendingIntensity30Default: '#fef8da',
  GlobalBackgroundFeedbackNeutralIntensity10Default: '#f4f4f4',
  GlobalBackgroundFeedbackNeutralIntensity20Default: '#ebecec',
  GlobalBackgroundFeedbackNeutralIntensity30Default: '#dedfdf',
  GlobalBackgroundFeedbackNeutralIntensity100Default: '#1c2222',
  GlobalBackgroundFeedbackStaffDefault: '#efb09c',
  GlobalBackgroundEquityCommonDefault: '#32b0a0',
  GlobalBackgroundEquityPreferredDefault: '#2c67b5',
  GlobalBackgroundEquityConvertibleDefault: '#634ba0',
  GlobalBackgroundEquityWarrantDefault: '#ea657f',
  GlobalBackgroundEquityOptionDefault: '#a7aaaa',
  GlobalBackgroundEquityPoolDefault: '#c4c4c4',
  GlobalBackgroundAccessoryAccent1Default: '#fbf8f7',
  GlobalBackgroundAccessoryAccent2Default: '#e1ddf2',
  GlobalBackgroundAccessoryAccent3Default: '#eaf0f8',
  GlobalBackgroundAccessoryAccent4Default: '#f4f4f4',
  GlobalBackgroundCtaPrimaryDefault: '#232b2b',
  GlobalBackgroundCtaPrimaryHover: '#394040',
  GlobalBackgroundCtaPrimaryDown: '#1a3e6d',
  GlobalBackgroundCtaPrimaryDisabled: '#dedfdf',
  GlobalBackgroundCtaSecondaryDefault: '#ffffff',
  GlobalBackgroundCtaSecondaryHover: '#ffffff',
  GlobalBackgroundCtaSecondaryDown: '#ffffff',
  GlobalBackgroundCtaSecondaryDisabled: '#ffffff',
  GlobalBackgroundCtaDangerDefault: '#c41936',
  GlobalBackgroundCtaDangerHover: '#da1c3c',
  GlobalBackgroundCtaDangerDown: '#ae1630',
  GlobalBackgroundCtaDangerDisabled: '#f8d2d8',
  GlobalBorderCtaPrimaryDefault: 'rgba(0, 0, 0, 0)',
  GlobalBorderCtaPrimaryHover: 'rgba(0, 0, 0, 0)',
  GlobalBorderCtaPrimaryKeyboardFocus: '#285da3',
  GlobalBorderCtaSecondaryDefault: '#c4c4c4',
  GlobalBorderCtaSecondaryHover: '#394040',
  GlobalBorderCtaSecondaryDown: '#1a3e6d',
  GlobalBorderCtaDangerDefault: 'rgba(0, 0, 0, 0)',
  GlobalBorderCtaDangerHover: 'rgba(0, 0, 0, 0)',
  GlobalBorderCtaDangerKeyboardFocus: '#831124',
  GlobalBorderCtaInverseDefault: 'rgba(0, 0, 0, 0)',
  GlobalBorderCtaInverseDown: '#285da3',
  GlobalBorderCtaInverseKeyboardFocus: '#285da3',
  GlobalBorderCtaFilterDefault: '#c4c4c4',
  GlobalBorderCtaFilterHover: '#394040',
  GlobalBorderCtaFilterDown: '#1a3e6d',
  GlobalBorderCtaFilterActive: '#1c2222',
  GlobalBorderSeparationWeakDefault: '#ebecec',
  GlobalBorderSeparationRegularDefault: '#dedfdf',
  GlobalBorderSeparationStrongDefault: '#c4c4c4',
  GlobalBorderInputBaseDefault: '#c4c4c4',
  GlobalBorderInputBaseHover: '#394040',
  GlobalBorderInputBaseKeyboardFocus: '#285da3',
  GlobalBorderInputBaseDisabled: '#ebecec',
  GlobalBorderInputInvalidDefault: '#c41936',
  GlobalBorderInputInvalidHover: '#c41936',
  GlobalBorderFeedbackInformationalIntensity40Default: '#8babd6',
  GlobalBorderFeedbackInformationalIntensity70Default: '#285da3',
  GlobalBorderFeedbackPositiveIntensity50Default: '#5bc0b3',
  GlobalBorderFeedbackPositiveIntensity60Default: '#32b0a0',
  GlobalBorderFeedbackNegativeIntensity30Default: '#f0a4b1',
  GlobalBorderFeedbackNegativeIntensity50Default: '#e14963',
  GlobalBorderFeedbackNoticeIntensity50Default: '#ea957b',
  GlobalBorderFeedbackNoticeIntensity60Default: '#e57b5a',
  GlobalBorderFeedbackPendingIntensity60Default: '#f8d648',
  GlobalBorderFeedbackNeutralIntensity50Default: '#a7aaaa',
  GlobalBorderFeedbackNeutralIntensity90Default: '#232b2b',
  GlobalBorderFeedbackStaffDefault: '#efb09c',
  GlobalBorderProgressionBaseDefault: '#656b6b',
  GlobalBorderProgressionBaseHover: '#232b2b',
  GlobalBorderProgressionBaseDisabled: '#a7aaaa',
  GlobalBorderProgressionBaseSelected: '#2c67b5',
  GlobalBorderContainerBaseDefault: '#dedfdf',
  GlobalBorderContainerTransparentDefault: 'rgba(0, 0, 0, 0)',
  GlobalBrandBlue10: '#eaf0f8',
  GlobalBrandBlue20: '#dfe8f4',
  GlobalBrandBlue30: '#c0d1e9',
  GlobalBrandBlue40: '#8babd6',
  GlobalBrandBlue50: '#4176bc',
  GlobalBrandBlue60: '#2c67b5',
  GlobalBrandBlue70: '#285da3',
  GlobalBrandBlue80: '#235291',
  GlobalBrandBlue90: '#1a3e6d',
  GlobalBrandBlue100: '#122948',
  GlobalBrandGreen10: '#ebf7f6',
  GlobalBrandGreen20: '#d6efec',
  GlobalBrandGreen30: '#addfd9',
  GlobalBrandGreen40: '#84d0c6',
  GlobalBrandGreen50: '#5bc0b3',
  GlobalBrandGreen60: '#32b0a0',
  GlobalBrandGreen70: '#2d9e90',
  GlobalBrandGreen80: '#237c70',
  GlobalBrandGreen90: '#1e6a60',
  GlobalBrandGreen100: '#144640',
  GlobalBrandLime10: '#fafdee',
  GlobalBrandLime20: '#f5fcd5',
  GlobalBrandLime30: '#ebfcac',
  GlobalBrandLime40: '#ddfb74',
  GlobalBrandLime50: '#c9ec56',
  GlobalBrandLime60: '#b1d636',
  GlobalBrandLime70: '#94b524',
  GlobalBrandLime80: '#738c12',
  GlobalBrandLime90: '#536507',
  GlobalBrandLime100: '#384202',
  GlobalBrandYellow10: '#fffef7',
  GlobalBrandYellow20: '#fffced',
  GlobalBrandYellow30: '#fef8da',
  GlobalBrandYellow40: '#fcefb6',
  GlobalBrandYellow50: '#fbe284',
  GlobalBrandYellow60: '#f8d648',
  GlobalBrandYellow70: '#ddb31f',
  GlobalBrandYellow80: '#b48804',
  GlobalBrandYellow90: '#825a00',
  GlobalBrandYellow100: '#4d2f00',
  GlobalBrandOrange10: '#fcf0ee',
  GlobalBrandOrange20: '#fae5de',
  GlobalBrandOrange30: '#f5cabd',
  GlobalBrandOrange40: '#efb09c',
  GlobalBrandOrange50: '#ea957b',
  GlobalBrandOrange60: '#e57b5a',
  GlobalBrandOrange70: '#ce6f51',
  GlobalBrandOrange80: '#b76248',
  GlobalBrandOrange90: '#a0563f',
  GlobalBrandOrange100: '#733e2d',
  GlobalBrandRed10: '#fbe8ec',
  GlobalBrandRed20: '#f8d2d8',
  GlobalBrandRed30: '#f0a4b1',
  GlobalBrandRed40: '#e9778a',
  GlobalBrandRed50: '#e14963',
  GlobalBrandRed60: '#da1c3c',
  GlobalBrandRed70: '#c41936',
  GlobalBrandRed80: '#ae1630',
  GlobalBrandRed90: '#831124',
  GlobalBrandRed100: '#570b18',
  GlobalBrandBrown10: '#fbf8f7',
  GlobalBrandBrown20: '#f0eae1',
  GlobalBrandBrown30: '#e2d5c2',
  GlobalBrandBrown40: '#ccb695',
  GlobalBrandBrown50: '#c5ab85',
  GlobalBrandBrown60: '#b69667',
  GlobalBrandBrown70: '#a4875d',
  GlobalBrandBrown80: '#7f6948',
  GlobalBrandBrown90: '#5b4b34',
  GlobalBrandBrown100: '#493c29',
  GlobalBrandGray10: '#f4f4f4',
  GlobalBrandGray20: '#ebecec',
  GlobalBrandGray30: '#dedfdf',
  GlobalBrandGray40: '#c4c4c4',
  GlobalBrandGray50: '#a7aaaa',
  GlobalBrandGray60: '#7b8080',
  GlobalBrandGray70: '#656b6b',
  GlobalBrandGray80: '#394040',
  GlobalBrandGray90: '#232b2b',
  GlobalBrandGray100: '#1c2222',
  GlobalBrandBlack: '#000000',
  GlobalBrandWhite: '#ffffff',
  GlobalCategoryCategory1Intensity10: '#eaf0f8',
  GlobalCategoryCategory1Intensity20: '#dfe8f4',
  GlobalCategoryCategory1Intensity30: '#c0d1e9',
  GlobalCategoryCategory1Intensity40: '#8babd6',
  GlobalCategoryCategory1Intensity50: '#4176bc',
  GlobalCategoryCategory1Intensity60: '#2c67b5',
  GlobalCategoryCategory1Intensity70: '#285da3',
  GlobalCategoryCategory1Intensity80: '#235291',
  GlobalCategoryCategory1Intensity90: '#1a3e6d',
  GlobalCategoryCategory1Intensity100: '#122948',
  GlobalCategoryCategory2Intensity10: '#ebf7f6',
  GlobalCategoryCategory2Intensity20: '#d6efec',
  GlobalCategoryCategory2Intensity30: '#addfd9',
  GlobalCategoryCategory2Intensity40: '#84d0c6',
  GlobalCategoryCategory2Intensity50: '#5bc0b3',
  GlobalCategoryCategory2Intensity60: '#32b0a0',
  GlobalCategoryCategory2Intensity70: '#2d9e90',
  GlobalCategoryCategory2Intensity80: '#237c70',
  GlobalCategoryCategory2Intensity90: '#1e6a60',
  GlobalCategoryCategory2Intensity100: '#144640',
  GlobalCategoryCategory3Intensity10: '#fbf8f7',
  GlobalCategoryCategory3Intensity20: '#f0eae1',
  GlobalCategoryCategory3Intensity30: '#e2d5c2',
  GlobalCategoryCategory3Intensity40: '#ccb695',
  GlobalCategoryCategory3Intensity50: '#c5ab85',
  GlobalCategoryCategory3Intensity60: '#b69667',
  GlobalCategoryCategory3Intensity70: '#a4875d',
  GlobalCategoryCategory3Intensity80: '#7f6948',
  GlobalCategoryCategory3Intensity90: '#5b4b34',
  GlobalCategoryCategory3Intensity100: '#493c29',
  GlobalCategoryCategory4Intensity10: '#fcf0ee',
  GlobalCategoryCategory4Intensity20: '#fae5de',
  GlobalCategoryCategory4Intensity30: '#f5cabd',
  GlobalCategoryCategory4Intensity40: '#efb09c',
  GlobalCategoryCategory4Intensity50: '#ea957b',
  GlobalCategoryCategory4Intensity60: '#e57b5a',
  GlobalCategoryCategory4Intensity70: '#ce6f51',
  GlobalCategoryCategory4Intensity80: '#b76248',
  GlobalCategoryCategory4Intensity90: '#a0563f',
  GlobalCategoryCategory4Intensity100: '#733e2d',
  GlobalCategoryCategory5Intensity10: '#fafdee',
  GlobalCategoryCategory5Intensity20: '#f5fcd5',
  GlobalCategoryCategory5Intensity30: '#ebfcac',
  GlobalCategoryCategory5Intensity40: '#ddfb74',
  GlobalCategoryCategory5Intensity50: '#c9ec56',
  GlobalCategoryCategory5Intensity60: '#b1d636',
  GlobalCategoryCategory5Intensity70: '#94b524',
  GlobalCategoryCategory5Intensity80: '#738c12',
  GlobalCategoryCategory5Intensity90: '#536507',
  GlobalCategoryCategory5Intensity100: '#384202',
  GlobalEquityPool: '#c4c4c4',
  GlobalEquityOption: '#a7aaaa',
  GlobalEquityCommon: '#32b0a0',
  GlobalEquityPreferred: '#2c67b5',
  GlobalEquityWarrant: '#ea657f',
  GlobalEquityConvertible: '#634ba0',
  GlobalFeedbackPositiveIntensity10: '#ebf7f6',
  GlobalFeedbackPositiveIntensity20: '#d6efec',
  GlobalFeedbackPositiveIntensity30: '#addfd9',
  GlobalFeedbackPositiveIntensity40: '#84d0c6',
  GlobalFeedbackPositiveIntensity50: '#5bc0b3',
  GlobalFeedbackPositiveIntensity60: '#32b0a0',
  GlobalFeedbackPositiveIntensity70: '#2d9e90',
  GlobalFeedbackPositiveIntensity80: '#237c70',
  GlobalFeedbackPositiveIntensity90: '#1e6a60',
  GlobalFeedbackPositiveIntensity100: '#144640',
  GlobalFeedbackNegativeIntensity10: '#fbe8ec',
  GlobalFeedbackNegativeIntensity20: '#f8d2d8',
  GlobalFeedbackNegativeIntensity30: '#f0a4b1',
  GlobalFeedbackNegativeIntensity40: '#e9778a',
  GlobalFeedbackNegativeIntensity50: '#e14963',
  GlobalFeedbackNegativeIntensity60: '#da1c3c',
  GlobalFeedbackNegativeIntensity70: '#c41936',
  GlobalFeedbackNegativeIntensity80: '#ae1630',
  GlobalFeedbackNegativeIntensity90: '#831124',
  GlobalFeedbackNegativeIntensity100: '#570b18',
  GlobalFeedbackNoticeIntensity10: '#fcf0ee',
  GlobalFeedbackNoticeIntensity20: '#fae5de',
  GlobalFeedbackNoticeIntensity30: '#f5cabd',
  GlobalFeedbackNoticeIntensity40: '#efb09c',
  GlobalFeedbackNoticeIntensity50: '#ea957b',
  GlobalFeedbackNoticeIntensity60: '#e57b5a',
  GlobalFeedbackNoticeIntensity70: '#ce6f51',
  GlobalFeedbackNoticeIntensity80: '#b76248',
  GlobalFeedbackNoticeIntensity90: '#a0563f',
  GlobalFeedbackNoticeIntensity100: '#733e2d',
  GlobalFeedbackPendingIntensity10: '#fffef7',
  GlobalFeedbackPendingIntensity20: '#fffced',
  GlobalFeedbackPendingIntensity30: '#fef8da',
  GlobalFeedbackPendingIntensity40: '#fcefb6',
  GlobalFeedbackPendingIntensity50: '#fbe284',
  GlobalFeedbackPendingIntensity60: '#f8d648',
  GlobalFeedbackPendingIntensity70: '#ddb31f',
  GlobalFeedbackPendingIntensity80: '#b48804',
  GlobalFeedbackPendingIntensity90: '#825a00',
  GlobalFeedbackPendingIntensity100: '#4d2f00',
  GlobalFeedbackNeutralIntensity10: '#f4f4f4',
  GlobalFeedbackNeutralIntensity20: '#ebecec',
  GlobalFeedbackNeutralIntensity30: '#dedfdf',
  GlobalFeedbackNeutralIntensity40: '#c4c4c4',
  GlobalFeedbackNeutralIntensity50: '#a7aaaa',
  GlobalFeedbackNeutralIntensity60: '#7b8080',
  GlobalFeedbackNeutralIntensity70: '#656b6b',
  GlobalFeedbackNeutralIntensity80: '#394040',
  GlobalFeedbackNeutralIntensity90: '#232b2b',
  GlobalFeedbackNeutralIntensity100: '#1c2222',
  GlobalFeedbackInformationalIntensity10: '#eaf0f8',
  GlobalFeedbackInformationalIntensity20: '#dfe8f4',
  GlobalFeedbackInformationalIntensity30: '#c0d1e9',
  GlobalFeedbackInformationalIntensity40: '#8babd6',
  GlobalFeedbackInformationalIntensity50: '#4176bc',
  GlobalFeedbackInformationalIntensity60: '#2c67b5',
  GlobalFeedbackInformationalIntensity70: '#285da3',
  GlobalFeedbackInformationalIntensity80: '#235291',
  GlobalFeedbackInformationalIntensity90: '#1a3e6d',
  GlobalFeedbackInformationalIntensity100: '#122948',
  GlobalFontHierarchyTitleDefault: '#232b2b',
  GlobalFontHierarchyLegendDefault: '#656b6b',
  GlobalFontHierarchyBodyDefault: '#1c2222',
  GlobalFontHierarchySecondaryDefault: '#ffffff',
  GlobalFontLinkBaseDefault: '#285da3',
  GlobalFontLinkBaseHover: '#1a3e6d',
  GlobalFontLinkBaseDown: '#1a3e6d',
  GlobalFontLinkBaseDisabled: '#a7aaaa',
  GlobalFontLinkInverseDefault: '#8babd6',
  GlobalFontLinkInverseDown: '#2c67b5',
  GlobalFontLinkInverseDisabled: '#a7aaaa',
  GlobalFontLinkUnderlineDefault: '#1c2222',
  GlobalFontLinkUnderlineHover: '#285da3',
  GlobalFontLinkUnderlineDown: '#1a3e6d',
  GlobalFontLinkUnderlineDisabled: '#a7aaaa',
  GlobalFontCustomBlackDefault: '#1c2222',
  GlobalFontCustomGrayDefault: '#656b6b',
  GlobalFontCustomWhiteDefault: '#ffffff',
  GlobalFontCustomBlueDefault: '#285da3',
  GlobalFontCustomRedDefault: '#c41936',
  GlobalFontCustomGreenDefault: '#2d9e90',
  GlobalFontProgressionActiveDefault: '#2c67b5',
  GlobalFontProgressionCompleteDefault: '#656b6b',
  GlobalFontProgressionDisabledDefault: '#a7aaaa',
  GlobalFontFeedbackInformationalIntensity70Default: '#285da3',
  GlobalFontFeedbackInformationalIntensity90Default: '#1a3e6d',
  GlobalFontFeedbackPositiveIntensity50Default: '#5bc0b3',
  GlobalFontFeedbackPositiveIntensity80Default: '#237c70',
  GlobalFontFeedbackPositiveIntensity90Default: '#1e6a60',
  GlobalFontFeedbackNegativeIntensity30Default: '#f0a4b1',
  GlobalFontFeedbackNegativeIntensity50Default: '#e14963',
  GlobalFontFeedbackNegativeIntensity70Default: '#c41936',
  GlobalFontFeedbackNegativeIntensity90Default: '#831124',
  GlobalFontFeedbackPendingIntensity90Default: '#825a00',
  GlobalFontFeedbackNoticeIntensity90Default: '#a0563f',
  GlobalFontFeedbackNeutralIntensity50Default: '#a7aaaa',
  GlobalFontFeedbackNeutralIntensity70Default: '#656b6b',
  GlobalFontFeedbackNeutralIntensity80Default: '#394040',
  GlobalFontFeedbackNeutralIntensity90Default: '#232b2b',
  GlobalFontFeedbackStaffDefault: '#000000',
  GlobalFontEquityCommonDefault: '#ffffff',
  GlobalFontEquityPreferredDefault: '#ffffff',
  GlobalFontEquityConvertibleDefault: '#ffffff',
  GlobalFontEquityWarrantDefault: '#ffffff',
  GlobalFontEquityOptionDefault: '#1c2222',
  GlobalFontEquityPoolDefault: '#1c2222',
  GlobalFontCtaPrimaryDefault: '#ebecec',
  GlobalFontCtaPrimaryDisabled: '#a7aaaa',
  GlobalFontCtaSecondaryDefault: '#1c2222',
  GlobalFontCtaSecondaryHover: '#394040',
  GlobalFontCtaSecondaryDown: '#1a3e6d',
  GlobalFontCtaSecondaryDisabled: '#a7aaaa',
  GlobalFontCtaDangerDefault: '#ebecec',
  GlobalFontCtaDangerDisabled: '#e9778a',
  GlobalFontCtaInverseDefault: '#ebecec',
  GlobalFontInputPlaceholderDefault: '#cecfd1',
  GlobalFontInputBaseDisabled: '#a7aaaa',
  GlobalGraphicForegroundCtaBaseHover: '#656b6b',
  GlobalGraphicForegroundScrollBaseDefault: '#656b6b',
  GlobalGraphicForegroundProgressionBaseDefault: '#656b6b',
  GlobalGraphicForegroundProgressionBaseHover: '#232b2b',
  GlobalGraphicForegroundProgressionBaseDown: '#2c67b5',
  GlobalGraphicForegroundInputBaseDefault: '#1c2222',
  GlobalGraphicForegroundInputBaseDisabled: '#a7aaaa',
  GlobalGraphicForegroundFeedbackPositiveContrastDefault: '#ffffff',
  GlobalGraphicForegroundFeedbackNoticeContrastDefault: '#ffffff',
  GlobalGraphicForegroundFeedbackNoticeIntensity60Default: '#e57b5a',
  GlobalGraphicForegroundFeedbackNoticeIntensity80Default: '#b76248',
  GlobalGraphicForegroundFeedbackNegativeContrastDefault: '#ffffff',
  GlobalGraphicForegroundFeedbackNeutralContrastDefault: '#ffffff',
  GlobalGraphicForegroundFeedbackPendingContrastDefault: '#000000',
  GlobalGraphicForegroundFeedbackInformationalContrastDefault: '#ffffff',
  GlobalGraphicForegroundFeedbackStaffContrastDefault: '#ffffff',
  GlobalGraphicBackgroundFeedbackPositiveIntensity60Default: '#32b0a0',
  GlobalGraphicBackgroundFeedbackNoticeIntensity60Default: '#e57b5a',
  GlobalGraphicBackgroundFeedbackNegativeIntensity60Default: '#da1c3c',
  GlobalGraphicBackgroundFeedbackNeutralIntensity40Default: '#c4c4c4',
  GlobalGraphicBackgroundFeedbackPendingIntensity60Default: '#f8d648',
  GlobalGraphicBackgroundFeedbackInformationalIntensity60Default: '#2c67b5',
  GlobalGraphicBackgroundFeedbackStaffDefault: '#e57b5a',
  GlobalOutlineBaseKeyboardFocus: '#285da3',
  GlobalOutlineInverseKeyboardFocus: '#285da3',
  GlobalShadowOuterSeparationSubtleDefault: 'rgba(0, 0, 0, 0.1)',
  GlobalShadowOuterSeparationStrongDefault: 'rgba(21, 22, 26, 0.3)',
  GlobalShadowOuterAccessibleBaseKeyboardFocus: '#285da3',
  GlobalShadowInputBaseKeyboardFocus: '#8babd6',
  GlobalShadowInputInvalidKeyboardFocus: '#e9778a',
  GlobalShadowCtaBaseKeyboardFocus: '#8babd6',
  GlobalShadowCtaDangerKeyboardFocus: '#e9778a',
  GlobalVisualizationPositiveIntensity0: '#a8d8bc',
  GlobalVisualizationPositiveIntensity1: '#79c298',
  GlobalVisualizationPositiveIntensity2: '#49a471',
  GlobalVisualizationPositiveIntensity3: '#2a8652',
  GlobalVisualizationPositiveIntensity4: '#156d3b',
  GlobalVisualizationPositiveDefault: '#49a471',
  GlobalVisualizationNegativeIntensity0: '#e9778a',
  GlobalVisualizationNegativeIntensity1: '#e14963',
  GlobalVisualizationNegativeIntensity2: '#da1c3c',
  GlobalVisualizationNegativeIntensity3: '#c41936',
  GlobalVisualizationNegativeIntensity4: '#ae1630',
  GlobalVisualizationNegativeDefault: '#da1c3c',
  GlobalVisualizationNeutralIntensity0: '#c4c4c4',
  GlobalVisualizationNeutralIntensity1: '#a7aaaa',
  GlobalVisualizationNeutralIntensity2: '#7b8080',
  GlobalVisualizationNeutralIntensity3: '#656b6b',
  GlobalVisualizationNeutralIntensity4: '#394040',
  GlobalVisualizationNeutralDefault: '#a7aaaa',
  GlobalVisualizationCategory1Intensity0: '#c0d1e9',
  GlobalVisualizationCategory1Intensity1: '#8babd6',
  GlobalVisualizationCategory1Intensity2: '#2c67b5',
  GlobalVisualizationCategory1Intensity3: '#235291',
  GlobalVisualizationCategory1Intensity4: '#1a3e6d',
  GlobalVisualizationCategory1Default: '#2c67b5',
  GlobalVisualizationCategory2Intensity0: '#addfd9',
  GlobalVisualizationCategory2Intensity1: '#84d0c6',
  GlobalVisualizationCategory2Intensity2: '#32b0a0',
  GlobalVisualizationCategory2Intensity3: '#237c70',
  GlobalVisualizationCategory2Intensity4: '#1e6a60',
  GlobalVisualizationCategory2Default: '#32b0a0',
  GlobalVisualizationCategory3Intensity0: '#e2d5c2',
  GlobalVisualizationCategory3Intensity1: '#ccb695',
  GlobalVisualizationCategory3Intensity2: '#c5ab85',
  GlobalVisualizationCategory3Intensity3: '#7f6948',
  GlobalVisualizationCategory3Intensity4: '#5b4b34',
  GlobalVisualizationCategory3Default: '#c5ab85',
  GlobalVisualizationCategory4Intensity0: '#f5cabd',
  GlobalVisualizationCategory4Intensity1: '#efb09c',
  GlobalVisualizationCategory4Intensity2: '#e57b5a',
  GlobalVisualizationCategory4Intensity3: '#b76248',
  GlobalVisualizationCategory4Intensity4: '#a0563f',
  GlobalVisualizationCategory4Default: '#e57b5a',
  GlobalVisualizationCategory5Intensity0: '#c9ec56',
  GlobalVisualizationCategory5Intensity1: '#b1d636',
  GlobalVisualizationCategory5Intensity2: '#94b524',
  GlobalVisualizationCategory5Intensity3: '#738c12',
  GlobalVisualizationCategory5Intensity4: '#536507',
  GlobalVisualizationCategory5Default: '#94b524',
} as const;

export const elevationTokens = {
  GlobalShadowOuterOffsetXSeparationNoneDefault: '0px',
  GlobalShadowOuterOffsetXSeparationSubtleDefault: '1px',
  GlobalShadowOuterOffsetXAccessibleBaseKeyboardFocus: '0px',
  GlobalShadowOuterOffsetYSeparationNegativeDefault: '-1px',
  GlobalShadowOuterOffsetYSeparationNoneDefault: '0px',
  GlobalShadowOuterOffsetYSeparationSubtleDefault: '1px',
  GlobalShadowOuterOffsetYSeparationExtraDefault: '4px',
  GlobalShadowOuterOffsetYAccessibleBaseKeyboardFocus: '0px',
  GlobalShadowOuterBlurSeparationNoneDefault: '0px',
  GlobalShadowOuterBlurSeparationSubtleDefault: '2px',
  GlobalShadowOuterBlurSeparationExtraDefault: '5px',
  GlobalShadowOuterBlurAccessibleBaseKeyboardFocus: '9px',
  GlobalShadowOuterSpreadSeparationNoneDefault: '0px',
  GlobalShadowOuterSpreadSeparationSubtleDefault: '1px',
  GlobalShadowOuterSpreadAccessibleBaseKeyboardFocus: '0px',
  GlobalNewTableRibbon: '20',
  GlobalNewTableHeaderFrozen: '12',
  GlobalNewTableHeaderInitial: '10',
  GlobalNewTableCellFrozen: '5',
  GlobalNewTableFooterInitial: '10',
  GlobalSpreadsheet: '20',
  GlobalDropdown: '25',
  GlobalCalendar: '100',
  GlobalDialogDefault: '1000',
  GlobalCelebration: '1050',
  GlobalTooltip: '1100',
  GlobalAlert: '2000',
  GlobalDoppelganger: '9999',
  GlobalEnvironment: '9999',
  GlobalSideNav: '21',
  GlobalGlobalFilter: '1100',
} as const;

export const fontTokens = {
  GlobalFamilyBase: '"Inter var", "fallback for Inter", sans-serif',
  GlobalFamilyProminent: '"SangBleu Versailles", "fallback for SangBleu", serif',
  GlobalFamilyCursive: 'dancingscript, cursive',
  GlobalFamilyMonospace: '"Roboto Mono", ui-monospace, Menlo, Monaco, monospace',
  GlobalFeatureBase: '"ss01", "cv05", "cv10", "calt"',
  GlobalLeadingDisplay1: '48px',
  GlobalLeadingDisplay2: '44px',
  GlobalLeadingHeading1Desktop: '48px',
  GlobalLeadingHeading1Mobile: '40px',
  GlobalLeadingHeading2Desktop: '36px',
  GlobalLeadingHeading2Mobile: '28px',
  GlobalLeadingHeading3: '28px',
  GlobalLeadingHeading4: '28px',
  GlobalLeadingBody1: '24px',
  GlobalLeadingBody2: '24px',
  GlobalLeadingBody3: '24px',
  GlobalLeadingSmall2: '20px',
  GlobalLeadingSmall1: '20px',
  GlobalSizeDisplay1: '28px',
  GlobalSizeDisplay2: '24px',
  GlobalSizeHeading1Desktop: '28px',
  GlobalSizeHeading1Mobile: '24px',
  GlobalSizeHeading2Desktop: '20px',
  GlobalSizeHeading2Mobile: '18px',
  GlobalSizeHeading3: '16px',
  GlobalSizeHeading4: '16px',
  GlobalSizeBody1: '14px',
  GlobalSizeBody2: '14px',
  GlobalSizeBody3: '14px',
  GlobalSizeSmall1: '12px',
  GlobalSizeSmall2: '12px',
  GlobalSizeMonospace: '13px',
  GlobalSpacingDisplay1: '16px',
  GlobalSpacingDisplay2: '16px',
  GlobalSpacingHeading1: '16px',
  GlobalSpacingHeading2: '16px',
  GlobalSpacingHeading3: '16px',
  GlobalSpacingHeading4: '16px',
  GlobalSpacingBody1: '8px',
  GlobalSpacingBody2: '8px',
  GlobalSpacingBody3: '8px',
  GlobalSpacingSmall1: '8px',
  GlobalSpacingSmall2: '8px',
  GlobalWeightDisplay1: '600',
  GlobalWeightDisplay2: '600',
  GlobalWeightHeading1: '400',
  GlobalWeightHeading2: '500',
  GlobalWeightHeading3: '500',
  GlobalWeightHeading4: '400',
  GlobalWeightBody1: '600',
  GlobalWeightBody2: '500',
  GlobalWeightBody3: '400',
  GlobalWeightSmall1: '500',
  GlobalWeightSmall2: '400',
  GlobalWeightMonospace: '400',
} as const;

export const sizeTokens = {
  GlobalBorderContainerSmallDefault: '1px',
  GlobalBorderContainerMediumDefault: '2px',
  GlobalBorderContainerLargeDefault: '4px',
  GlobalBorderProgressionInactiveDefault: '1px',
  GlobalBorderProgressionActiveDefault: '2px',
  GlobalBorderHighlightBaseDefault: '5px',
  GlobalBorderBlockquoteDefault: '8px',
  GlobalOutlineWidthAccessibleBaseKeyboardFocus: '2px',
  GlobalOutlineStyleAccessibleBaseKeyboardFocus: 'solid',
  GlobalOutlineStrokeAccessibleBaseKeyboardFocus: '2px solid',
  GlobalOutlineOffsetAccessibleTightKeyboardFocus: '0px',
  GlobalOutlineOffsetAccessibleLooseKeyboardFocus: '2px',
  GlobalRadiusNone: '0px',
  GlobalRadiusSmall: '3px',
  GlobalRadiusMedium: '4px',
  GlobalRadiusNormal: '8px',
  GlobalRadiusLarge: '16px',
  GlobalRadiusXlarge: '24px',
  GlobalRadiusRound: '50%',
} as const;

export const spacingTokens = {
  GlobalVerticalXxsmall: '4px',
  GlobalVerticalXsmall: '8px',
  GlobalVerticalSmall: '12px',
  GlobalVerticalNormal: '16px',
  GlobalVerticalGutter: '20px',
  GlobalVerticalLarge: '24px',
  GlobalVerticalXlarge: '32px',
  GlobalHorizontalXxsmall: '4px',
  GlobalHorizontalXsmall: '8px',
  GlobalHorizontalSmall: '12px',
  GlobalHorizontalNormal: '16px',
  GlobalHorizontalGutter: '20px',
  GlobalHorizontalLarge: '24px',
  GlobalHorizontalXlarge: '32px',
  GlobalHorizontalXxlarge: '40px',
} as const;
